module.exports = function() {
  return new Worker(__webpack_public_path__ + "070d99eeaa57ee1ea2c3.worker.js");
};